/**
 * Lots proposés par le widget `lot` (ADR-146 addendum (6)) : les lots actifs lus par la liste d'objets
 * de la tâche, gardés seulement s'ils ont un solde disponible positif (ERP-STOCK-005 : ni bloqué, ni
 * rappelé, ni épuisé). Fonction pure, même règle au navigateur et à la tablette (jeu `gs1-scan.cases.json`).
 * Les quantités restent des chaînes décimales : seul leur signe est lu, jamais un nombre flottant.
 */
/** Vrai pour une chaîne décimale strictement positive (`12.500`, `0.001`), sans conversion en nombre. */
export function positiveDecimal(value) {
    if (typeof value !== 'string' || !/^\+?\d+(\.\d+)?$/.test(value.trim()))
        return false;
    return /[1-9]/.test(value);
}
const idOf = (value) => (value === null || value === undefined ? undefined : String(value));
/** Lots actifs à solde disponible positif, dans l'ordre de la liste lue (date limite la plus proche d'abord si elle est triée ainsi). */
export function lotsInStock(lots, balances) {
    const stocked = new Set();
    for (const balance of balances) {
        const lot = idOf(balance.lot_id);
        if (lot !== undefined && (balance.stock_state === undefined || balance.stock_state === 'available') && positiveDecimal(balance.exact_value))
            stocked.add(lot);
    }
    const proposals = [];
    for (const lot of lots) {
        const id = idOf(lot.id);
        if (id === undefined || lot.status !== 'active' || typeof lot.lot_code !== 'string' || lot.lot_code === '' || !stocked.has(id))
            continue;
        const expiry = typeof lot.expiry_date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(lot.expiry_date) ? lot.expiry_date : undefined;
        proposals.push({ lot_id: id, lot_code: lot.lot_code, ...(expiry === undefined ? {} : { expiry_date: expiry }) });
    }
    return proposals;
}
/** Le numéro saisi est-il un lot proposé ? Comparaison exacte après rognage (un lot est une chaîne lexicale). */
export function lotKnown(code, proposals) {
    return typeof code === 'string' && proposals.some((proposal) => proposal.lot_code === code.trim());
}
//# sourceMappingURL=lot-proposals.js.map